import { ReactNode, ReactElement } from 'react';

import { UploadFile } from 'antd';
import { ossSignUrl, getFileMD5, getOSSUploadSignUrl } from '@/api/grt/upload';
export enum UploadType {
    // eslint-disable-next-line no-unused-vars
    UNSET,
    // eslint-disable-next-line no-unused-vars
    IMAGE = 4,
    // eslint-disable-next-line no-unused-vars
    VIDEO = 2,
    // eslint-disable-next-line no-unused-vars
    AUDIO,
    // eslint-disable-next-line no-unused-vars
    DOCS = 5,
    // eslint-disable-next-line no-unused-vars
    USER_AVATAR,
    // eslint-disable-next-line no-unused-vars
    APP,
    // eslint-disable-next-line no-unused-vars
    AI = 21,
    AGENT
}
export interface Props {
    sizeTip?: string;
    typeTip?: string;
    /** 自定义上传元素*/
    uploadItem?: ReactNode;
    customUploadType?: Array<string>;
    uploadType?: UploadType;
    /** 自定义class*/
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onChange?: (file: UploadFile) => void;
    dirname?: string;
    /** 桶名*/
    bucketName: string;
    ossBucketName?: string;
    /** 上传前回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    beforeUpload?: (file: UploadFile, name: string, md5: string) => Promise<boolean | undefined | void>;
    /** 上传中回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars

    // eslint-disable-next-line no-unused-vars
    ossProcessFunc?: (processNumber: number, file: UploadFile, xhr: XMLHttpRequest, obsResult: any) => void;
    /** 上传完成回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars

    // eslint-disable-next-line no-unused-vars
    ossUploadCompleteFunc?: (obsResult: any, file: UploadFile) => void;
    /** 上传失败回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars
    ossErrorFunc?: (error: any, file: UploadFile, obsResult: any) => void;
    // eslint-disable-next-line no-unused-vars
    itemRender?: (originNode: ReactElement, file: UploadFile, fileList: object[], actions: any) => ReactNode;
    /** 文件大小限制*/
    maxSize?: number;
    /** 多个文件上传*/
    multiple?: boolean;
    disabled?: boolean;
}
const obsSignUrl = ossSignUrl;

const xhrUploadFile = (
    uploadUrl: string,
    file: any,
    headers: any,
    obsResult: any,
    ossProcessFunc?: (processNumber: number, file: UploadFile, xhr: XMLHttpRequest, obsResult: any) => void,
    ossErrorFunc?: (error: any, file: UploadFile, obsResult: any) => void
) => {
    const xhr = new XMLHttpRequest();
    xhr.open('put', uploadUrl);
    for (let key in headers) {
        const value = headers[key];
        if (key) {
            xhr.setRequestHeader(key, value);
        }
    }
    xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && ossProcessFunc) {
            // 创建一个模拟的 UploadFile 对象用于回调
            const mockFile: UploadFile = {
                uid: '',
                name: file.name || '',
                status: 'uploading',
                percent: (event.loaded / event.total) * 100
            };
            ossProcessFunc(event.loaded / event.total, mockFile, xhr, obsResult);
        }
    };
    xhr.onerror = (err) => {
        if (obsResult.type === 'oss' && ossErrorFunc) {
            console.error(err);
            // 创建一个模拟的 UploadFile 对象用于回调
            const mockFile: UploadFile = {
                uid: '',
                name: file.name || '',
                status: 'error'
            };
            ossErrorFunc(err, mockFile, obsResult);
        }
    };
    xhr.onload = () => {
        if (xhr.status === 200) {
            console.log('complete:');
            const url: string = xhr.responseURL;
            obsResult.fileUrl = url.substring(0, url.indexOf('?'));
        }
    };
    xhr.send(file);
    return xhr;
};

// ... existing code ...
export const uploadFileWithMD5 = async (props) => {
    let { file, fileExt, ossProcessFunc, ossErrorFunc, ossUploadCompleteFunc } = props;
    try {
        const md5: any = await getFileMD5(file);
        const rename = md5 + '.' + fileExt;
        const fileKey = props.dirname ? props.dirname + '/' + rename : rename;

        if (!props.ossBucketName) {
            throw new Error('ossBucketName is required');
        }

        const { success: ossSuccess, data: ossData } = await getOSSUploadSignUrl(obsSignUrl, props.ossBucketName, fileKey);

        if (ossSuccess && ossData) {
            const url = ossData;
            const obsResult = {
                bucketName: props.ossBucketName,
                objectKey: fileKey,
                type: 'oss',
                md5,
                ext: fileExt,
                fileUrl: '' // 初始化fileUrl
            };

            // 修改xhrUploadFile调用，添加完成回调处理
            const xhr = xhrUploadFile(url, file, { 'Content-Type': 'multipart/form-data' }, obsResult, ossProcessFunc, (error, file, obsResult) => {
                if (ossErrorFunc) {
                    ossErrorFunc(error, file, obsResult);
                }
            });

            // 监听上传完成事件
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // 设置fileUrl
                    const fullUrl = xhr.responseURL;
                    obsResult.fileUrl = fullUrl.substring(0, fullUrl.indexOf('?'));

                    // 调用上传完成回调
                    if (ossUploadCompleteFunc) {
                        const mockFile: UploadFile = {
                            uid: '',
                            name: file.name || '',
                            status: 'done',
                            percent: 100
                        };
                        ossUploadCompleteFunc(obsResult, mockFile);
                    }
                } else {
                    // 处理上传失败
                    if (ossErrorFunc) {
                        const error = new Error(`Upload failed with status: ${xhr.status}`);
                        const mockFile: UploadFile = {
                            uid: '',
                            name: file.name || '',
                            status: 'error'
                        };
                        ossErrorFunc(error, mockFile, obsResult);
                    }
                }
            };

            return obsResult;
        }
    } catch (error) {
        console.error('Upload failed:', error);
        if (ossErrorFunc) {
            const mockFile: UploadFile = {
                uid: '',
                name: file.name || '',
                status: 'error'
            };
            ossErrorFunc(error, mockFile, {});
        }
        throw error;
    }
};
// ... existing code ...
